import React from "react";
import { Button } from "components";
import AddResourceIcon from "assets/icons/plus.svg";
import { useTranslation } from "react-i18next";

interface AddLibraryResourceButtonProps {
  onClick: () => void;
  title?: string;
}

const AddLibraryResourceButton = ({
  onClick,
  title,
}: AddLibraryResourceButtonProps) => {
  const { t } = useTranslation(["common"]);

  return (
    <Button
      name="add_resource_button"
      value={title || t("resources.add_resource_button")}
      icon={AddResourceIcon}
      onClick={onClick}
      size="small"
      pill
    />
  );
};

export default AddLibraryResourceButton;
